export type StatsigTier = 'production' | 'staging';

export function getStatsigTierFromEnv(
  appEnv: string | undefined,
  mode: string | undefined,
): StatsigTier {
  const raw = (appEnv ?? '').trim() || (mode ?? '').trim();
  const effective = raw.toLowerCase();
  return effective === 'production' || effective === 'prod'
    ? 'production'
    : 'staging';
}
